var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadfileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12686",
    "data-name": "Group 12686",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.73,
    height: 34.083,
    viewBox: "0 0 42.73 34.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_38495",
    x: 24.815,
    y: 14.445,
    width: 17.334,
    height: 19.638,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12682",
    "data-name": "Group 12682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38492",
    "data-name": "Path 38492",
    d: "M9.159,6.367h26.92A1.116,1.116,0,0,0,37.2,5.25V3.891a1.116,1.116,0,0,0-1.117-1.117H16.063a1.118,1.118,0,0,1-.988-.594L14.234.594A1.116,1.116,0,0,0,13.247,0H1.113A.948.948,0,0,0,1,.006a1.117,1.117,0,0,0-1,1.225l2.69,26.1L4,27.512,7.472,7.986A2,2,0,0,1,9.159,6.367",
    transform: "translate(0)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38493",
    "data-name": "Path 38493",
    d: "M27.033,20.274H22.041l9.862-8.68,6.334,5.575,1.59-5.246.262-.834.969-3.21a2.073,2.073,0,0,0-1.975-2.687H8.729A2.073,2.073,0,0,0,6.687,6.946L4.139,23.461a2.076,2.076,0,0,0,1.744,2.362,2.018,2.018,0,0,0,.3.024H27.033Z",
    transform: "translate(1.58 1.992)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38494",
    "data-name": "Path 38494",
    d: "M28.239,16.091h-.522v1.721Z",
    transform: "translate(10.637 6.175)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_38495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38495-2",
    "data-name": "Path 38495",
    d: "M33.351,17.109,26.185,10.8l-7.168,6.309h3.2v10.33h7.935V17.109Z",
    transform: "translate(7.3 4.14)",
    fill: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadfileicon);
export default __webpack_public_path__ + "static/media/Upload file icon.84e5c050de796c8caab67b3b29688db2.svg";
export { ForwardRef as ReactComponent };